module.exports = __webpack_public_path__ + "static/media/logo-negative2.a1cb4dca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-negative2.svg
// module id = 554
// module chunks = 9